import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { startModifyForm } from '../../../redux/actions/form';
import { TitleBlock } from '../../../components/blocks/TitleBlock';
import { AlertBlock } from '../../../components/blocks/AlertBlock';
import { ProgressBlock } from '../../../components/blocks/ProgressBlock';
import { ParagraphBlock } from '../../../components/blocks/ParagraphBlock';
import { ToggleOption } from '../../../components/inputs/ToggleOption';
import { TextInput } from '../../../components/inputs/TextInput';
import { ActionBar } from '../../../components/toolbars/ActionBar';
import { LiveAloneOptions } from '../../../enums/LiveAloneOptions';
import { CircularProgress, Box, Typography } from '@material-ui/core';
import axios from 'axios';
import { FORM_TYPES, getStepData } from '../../../enums/Steps';
import { useLanguage } from "../../../hooks/useLanguage";

export const JourneyPostcodeForm = (props) => {
  const form = useSelector((state) => state.form[0]);
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const [postcodeLoading, setPostcodeLoading] = useState(false);
  const [postcodeError, setPostcodeError] = useState('');
  const handleLivingArrangementsSelect = (livingArrangements) => {
    dispatch(startModifyForm({ ...form, patientLivingArrangements: livingArrangements }));
  };

  const step = 'postcode';
  const { nextStep, prevStep, currentStepIndicator } = getStepData(
    step,
    FORM_TYPES.journey,
    t
  );

  const actionBarCopy = t('2_of_5');

  const handlePostcodeInput = (postcode) => {
    setPostcodeLoading(true);

    let data = {
      key: form.key,
      postcode: postcode.target.value,
    };
    if (data.postcode.length >= 6) {
      axios
        .post(`${process.env.REACT_APP_API_ENDPOINT}/survey/convert-postcode`, data)
        .then((res) => {
          setPostcodeLoading(false);
          setPostcodeError('');
          dispatch(startModifyForm({ ...form, patientPostcode: res.data.lsoa11cd }));
        })
        .catch((err) => {
          setPostcodeLoading(false);
          if (err.response?.error_message) {
            setPostcodeError(err?.response?.error_message);
          } else {
            setPostcodeError('Oops, something went wrong!');
          }
        });
    }
  };

  const [validation, setValidation] = useState(false);
  const validate = () => {
    setValidation(true);
  };

  const translatedLiveAloneOptions = LiveAloneOptions.map((option) => {
    return {
      ...option,
      name: t(option.value),
    };
  })

  return (
    <React.Fragment>
      <ProgressBlock value1={currentStepIndicator} value2={0} />
      <div className={'inner-form-container'}>
        <br />
        <ParagraphBlock decoration={'icon'} background={'white'} copy={t('journey_home_info')} />
        <TitleBlock copy={t('journey_home_question_1')} />
        <ToggleOption
          options={translatedLiveAloneOptions}
          handleSelect={handleLivingArrangementsSelect}
          selected={form.patientLivingArrangements}
          validation={validation}
        />
        <AlertBlock active={postcodeError} copy={postcodeError} />
        <TitleBlock copy={t('journey_home_question_2')} />
        <TextInput handleKeyUp={handlePostcodeInput} defaultValue={form.patientPostcode} />
        {postcodeLoading && (
          <Box display={'flex'} justifyContent={'center'} mt={1}>
            <CircularProgress />
          </Box>
        )}
        {postcodeError && (
          <Box my={1}>
            <Typography variant={'subtitle1'} align={'center'} className={'red-font'}>
              {postcodeError}
            </Typography>
          </Box>
        )}
      </div>
      <ActionBar
        prevState={prevStep}
        handleValidation={validate}
        copy={actionBarCopy}
        nextState={form.patientLivingArrangements ? (form.patientPostcode ? nextStep : '') : ''}
      />
    </React.Fragment>
  );
};
